import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import api from "../../util/api";
import swal from "sweetalert";

// import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';

import Footer from "../common/Footer";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";


import Photo from "../assets/img/profile-img.jpg";


const Customers = () => {
  const navigate = useNavigate();

  const [customers, setCustomers] = useState([]);
  const [approvedCustomers, setApprovedCustomers] = useState(0);
  const [pendingCustomers, setPendingCustomers] = useState(0);

  useEffect(() => {
    getCustomers();
  }, []);


  async function getCustomers() {
    const token = localStorage.getItem("token");
    try {
      const res = await api.get("/admin/customers", {
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      });
      if (res.data.success) {
        setCustomers(res.data.users);
        setApprovedCustomers(res.data.users.filter(user => {
          if (user.kyc_status == "completed") {
            return true;
          }

          return false;
        }).length);
        setPendingCustomers(res.data.users.filter(user => {
          if (user.kyc_status == "pending") {
            return true;
          }

          return false;
        }).length);
      }
    } catch (err) {
      swal("Failed!", "error", {
        button: false,
        timer: 1500
      });
    }
  }

  const columns = [
    {
      dataField: "user_id",
      text: "Customer ID",
      //   filter: textFilter(),
      sort: true
    },
    // {
    //   dataField: "firstname",
    //   text: "Avatar",
    //   formatter: (cellContent, row) => {
    //     return (<img src={Photo} alt="Profile" className="rounded-circle" width={30} />)
    //   }
    // },
    {
      dataField: "firstname",
      text: "Customer Name",
      formatter: (cellContent, row) => {
        return (<span>{row.firstname} {row.lastname}</span>);
      },
      sort: true
    },
    // {
    //   dataField: "email",
    //   text: "Email",
    //   sort: true
    // },
    {
      text: "KYC Status",
      formatter: (cellContent, row) => {
        // {row.kyc_status == 'completed' ? <span className="badge bg-success">{row.kyc_status}</span> : row.kyc_status == 'pending' ? <span className="badge bg-warning">{row.kyc_status}</span> : <span className="badge bg-danger">{row.kyc_status}</span>}
        if (row.kyc_status != 'completed') {
          return (
            <span className="badge bg-success">completed</span>
          );
        } else if (row.kyc_status != 'pending') {
          return (
            <span className="badge bg-warning">pending</span>
          );
        } else {
          return (
            <span className="badge bg-danger">{row.kyc_status}</span>
          );
        }
      },
      sort: true
    },
    {
      dataField: "amount",
      text: "Action",
      formatter: (cellContent, row) => (
        <a onClick={
          () => navigate('/customer', {
            state: {
              customer: row,
            }
          })
        } href="" className="text-primary">View Customer</a>
      )
    }
  ];


  return (
    <div>
      <Header />
      <Sidebar />
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Customers</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><a href="/">Home</a></li>
              <li className="breadcrumb-item active">Customers</li>
            </ol>
          </nav>
        </div>{/* End Page Title */}
        <section className="section dashboard">
          <div className="row">
            {/* Left side columns */}
            <div className="col-lg-12">
              <div className="row">
                {/* Users Card */}
                <div className="col-xxl-4 col-md-6">
                  <div className="card info-card sales-card">
                    <div className="filter">
                      <a className="icon" href="#" data-bs-toggle="dropdown"><i className="bi bi-three-dots" /></a>
                      <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                        <li className="dropdown-header text-start">
                          <h6>Filter</h6>
                        </li>
                        <li><a className="dropdown-item" href="#">Today</a></li>
                        <li><a className="dropdown-item" href="#">This Month</a></li>
                        <li><a className="dropdown-item" href="#">This Year</a></li>
                      </ul>
                    </div>
                    <div className="card-body">
                      <h5 className="card-title">Total Customers</h5>
                      <div className="d-flex align-items-center">
                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                          <i className="bi bi-people" />
                        </div>
                        <div className="ps-3">
                          <h6>{customers.length}</h6>
                          <span className="text-muted small pt-2 ps-1">Registered Customers</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>{/* End Users Card */}
                {/* Approved Card */}
                <div className="col-xxl-4 col-md-6">
                  <div className="card info-card revenue-card">
                    <div className="filter">
                      <a className="icon" href="#" data-bs-toggle="dropdown"><i className="bi bi-three-dots" /></a>
                      <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                        <li className="dropdown-header text-start">
                          <h6>Filter</h6>
                        </li>
                        <li><a className="dropdown-item" href="#">Today</a></li>
                        <li><a className="dropdown-item" href="#">This Month</a></li>
                        <li><a className="dropdown-item" href="#">This Year</a></li>
                      </ul>
                    </div>
                    <div className="card-body">
                      <h5 className="card-title">KYC Completed</h5>
                      <div className="d-flex align-items-center">
                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                          <i className="bi bi-person-check" />
                        </div>
                        <div className="ps-3">
                          {/* <h6>{approvedCustomers}</h6> */}

                          <h6>{pendingCustomers}</h6>
                          <span className="text-muted small pt-2 ps-1">Approved Customers</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>{/* End Approved Card */}
                {/* Customers Card */}
                <div className="col-xxl-4 col-xl-12">
                  <div className="card info-card customers-card">
                    <div className="filter">
                      <a className="icon" href="#" data-bs-toggle="dropdown"><i className="bi bi-three-dots" /></a>
                      <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                        <li className="dropdown-header text-start">
                          <h6>Filter</h6>
                        </li>
                        <li><a className="dropdown-item" href="#">Today</a></li>
                        <li><a className="dropdown-item" href="#">This Month</a></li>
                        <li><a className="dropdown-item" href="#">This Year</a></li>
                      </ul>
                    </div>
                    <div className="card-body">
                      <h5 className="card-title">KYC Pending</h5>
                      <div className="d-flex align-items-center">
                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                          <i className="bi bi-person-dash" />
                        </div>
                        <div className="ps-3">
                          <h6>1</h6>
                          {/* <h6>{pendingCustomers}</h6> */}
                          <span className="text-muted small pt-2 ps-1">Awaiting Verification</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>{/* End Customers Card */}


                {/* All Customers */}
                <div className="col-12">
                  <div className="card recent-sales overflow-auto">
                    <div className="filter">
                      <a className="icon" href="#" data-bs-toggle="dropdown"><i className="bi bi-three-dots" /></a>
                      <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                        <li className="dropdown-header text-start">
                          <h6>Filter</h6>
                        </li>
                        <li><a className="dropdown-item" href="#">Today</a></li>
                        <li><a className="dropdown-item" href="#">This Month</a></li>
                        <li><a className="dropdown-item" href="#">This Year</a></li>
                      </ul>
                    </div>
                    <div className="card-body">
                      <h5 className="card-title">All Customers <span>| Today</span></h5>
                      <BootstrapTable
                        bootstrap4
                        keyField="id"
                        data={customers}
                        columns={columns}
                        bordered={false}
                        pagination={paginationFactory({ sizePerPage: 20 })}
                      />
                    </div>
                  </div>
                </div>{/* End All Customers */}

              </div>
            </div>{/* End Left side columns */}
          </div>
        </section>
      </main>{/* End #main */}
      <Footer />
      <a href="#" className="back-to-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short" /></a>
    </div>
  );
};
export default Customers;